import {createContext, useContext, useEffect, useState} from "react";
import axiosInstance from "../../services/axios";
import {useSearchParams} from "react-router-dom";
import ViaqTryCatch from "../../services/GlobalTryCatch";
import {useModal} from "../../tools/useModal";
import moment from "jalali-moment";

export const ClientDetailDevicesHeaders = [

    {name: "شماره سریال", key: "serialNumber"},
    {name: "نام دستگاه", key: "name"},
    {name: "نوع کاربری", key: "userType"},
    {name: "گارانتی", key: "warranty"},
    {name: "آخرین وضعیت", key: "deviceLastConnection"},
]
export const ClientDetailTransactionHeaders = [

    {name: "شماره تراکنش", key: "transActionNumber"},
    {name: "شماره فاکتور", key: "invoiceNumber"},
    {name: "مبلغ (تومان)", key: "convertedAmount"},
    {name: "تاریخ", key: "convertedDate"},
    {name: "توضیحات", key: "description"},
    {name: "وضعیت", key: "status"},
]
const detailContext = createContext();

function eArabic(x) {
    return x.toLocaleString("fa-IR");
}

const convertToPersianDate = (dateString) => {
    return moment(dateString).locale('fa').format('jYYYY/jMM/jDD-HH:mm');
};
const getLocationDisplay = (province, city) => {
    if (province === "ثبت نشده" && city === "ثبت نشده") {
        return "ثبت نشده";
    }

    if (province === "ثبت نشده") {
        return city;
    }
    if (city === "ثبت نشده") {
        return province;
    }

    return `${province}, ${city}`;
};

export function ClientDetailContextProvider({children}) {
    const [searchParams, setSearchParams] = useSearchParams();
    const params = new URLSearchParams(searchParams);

    const [clientDetailData, setClientDetailData] = useState()
    const {closeModal, openModal, modalState} = useModal();
    const [devicesList, setDevicesList] = useState([])
    const [transactionList, setTransactionList] = useState([])
    const [userBaseInfo, setUserBaseInfo] = useState()
    const [subscriptionInfo, setSubscriptionInfo] = useState()
    const [loading, setLoading] = useState(true)

    async function getClientDetail() {
        const id = params.get("id");
        setLoading(true)
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/client/details", {
                    id: id
                })
            });

        const newDevicesList = response.data.devices.map((device) => {
            return {
                ...device,
                userType: device.isOwner ? "مالک" : "مهمان",
                warranty: device.daysLeftUntilEndGuarantee <= 0 ? "ندارد" : "دارد"
            }

        })
        const newTransactionList = response.data.transactions.map((transaction) => {
            return {
                ...transaction,
                convertedAmount: eArabic(transaction.amount),
                convertedDate: convertToPersianDate(transaction.date)
            }
        })
        const newUserInfo = response.data.base;
        newUserInfo.phoneNumber = response.data.base.phoneNumber.replace("+98", "0")
        newUserInfo.location = getLocationDisplay(newUserInfo.province, newUserInfo.city)
        setUserBaseInfo(newUserInfo)
        setTransactionList(newTransactionList)
        setDevicesList(newDevicesList)
        setSubscriptionInfo(response.data.subscription);
        setLoading(false)

    }


    useEffect(() => {
        getClientDetail();

    }, []);

    function onDeviceDelete(item) {
        openModal("device", item)
    }

    function onBrokerDelete(item) {
        openModal("broker", item)
    }


    return (
        <detailContext.Provider value={{
            onDeviceDelete, onBrokerDelete, clientDetailData, devicesList,
            modalState,
            closeModal,
            subscriptionInfo,
            userBaseInfo,
            transactionList,
            loading
        }}
        >
            {children}
        </detailContext.Provider>
    )
}

export function ClientDetailUseContext() {
    return useContext(detailContext);

}

